import { isEmpty } from 'lodash-es';
import { hasImage } from '@klv/shared/utils/functions';
import { LIGHT_BACKGROUNDS } from '@klv/shared/utils/variables';
import type { IMixedMedia } from '@klv/molecules/mixed-media/types';
import type { TBody } from '../types';

export const hasMixedMedia = (mixedMedia?: IMixedMedia): boolean => {
  if (!isEmpty(mixedMedia)) {
    if (mixedMedia.mediaType === 'image') {
      // Support both Gatsby and Astro image formats
      return hasImage(mixedMedia.image) || !!(mixedMedia.image?.sourceUrl);
    }
    if (mixedMedia.mediaType === 'rive') {
      return !!mixedMedia.rive?.riveFile;
    }
    if (mixedMedia.mediaType === 'rive_animation') {
      return !!mixedMedia.riveAnimation?.riveAnimation?.riveFile?.mediaItemUrl;
    }
    return hasImage(mixedMedia?.video?.poster) && !!mixedMedia?.video?.videoUrl;
  }

  return false;
};

export const getBackgroundStyle = (backgroundColor?: string): 'poppy' | 'lemon' => {
  return LIGHT_BACKGROUNDS.concat('light').includes(backgroundColor || '') ? 'poppy' : 'lemon';
};

export const isQuote = (body?: TBody[]): boolean => {
  return !!(body && body?.length > 0 && body[0]?.bodyType?.includes('Quote')) ||
         !!(body && body?.length > 0 && body[0]?.quote);
};
